module.exports = __webpack_public_path__ + "static/media/Asset 7@3x.7835f318.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Avatar/Asset 7@3x.png
// module id = 2397
// module chunks = 0